import { VideoComponentFragment } from '@/__generated__/graphql';
import { useMobile } from "@lib/hooks/useMobile";
import { GridWrapper } from '@theme/lib';
import IFrameResizer from "iframe-resizer-react";
import { ReactElement } from 'react';
import { StyledVideo } from './VideoComponent.styles';

export interface VideoComponentProps {
  id: string;
  alignment: string;
  video: {
    id: string;
    url: string;
    thumbnail: string | null;
  };
  videoType: string;
}


export default function VideoComponent(data: VideoComponentFragment): ReactElement<any> {
  const isMobile = useMobile();

  return (
    <GridWrapper alignment={data.alignment}>
      <StyledVideo videoType={data.videoType}>
        <IFrameResizer src={data.video.url} allow="fullscreen" referrerPolicy="strict-origin-when-cross-origin" />
      </StyledVideo>
    </GridWrapper>
  );
}
